// console.log("math");
Object.defineProperties(Math, {
        precision: {
            value(num, precision = 0) {
                const exp = 10 ** precision;
                return this.round(num * exp) / exp;
            }
        }
    }
)